class LiveSearchWrapper extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    this.liveSearch = this.querySelector("live-search");
    this.clear = this.querySelector("[data-clear]");

    if (!this.input || !this.liveSearch) return;

    this.toggleClearVisibility();

    this.input.addEventListener("input", () => {
      this.liveSearch.setAttribute("q", this.input.value);
      this.toggleClearVisibility();

      if (!this.input.value.length) {
        this.updateAriaLiveContent("");
      }
    });

    this.input.addEventListener("focus", () => {
      this.setAttribute("interacting", "");
    });

    this.clearValue = () => {
      this.input.value = "";
      this.updateAriaLiveContent("");
      this.liveSearch.setAttribute("q", "");
      this.toggleClearVisibility();
    };

    const handleClear = () => {
      this.dispatchEvent(
        new CustomEvent("header-search:close", { bubbles: true }),
      );
      this.removeAttribute("interacting");
      this.clearValue();
    };

    this.clear?.addEventListener("click", handleClear);

    this.addEventListener("live-search-wrapper:clear", this.clearValue);

    this.handleMenuClose = () => {
      this.clearValue();
      this.removeAttribute("interacting");
    };

    document.addEventListener("mobile-menu:closed", this.handleMenuClose);

    this.addEventListener("live-search:updated", (e) => {
      const { ariaLiveContent } = e.detail;
      this.updateAriaLiveContent(ariaLiveContent);
    });
  }

  disconnectedCallback() {
    document.removeEventListener("mobile-menu:closed", this.handleMenuClose);
  }

  toggleClearVisibility() {
    this.toggleAttribute("active", this.input.value.length);
  }

  updateAriaLiveContent(content) {
    const ariaLive = this.querySelector('[aria-live="assertive"]');

    ariaLive.innerHTML = this.input.value.length ? content : "";
  }
}

if (!customElements.get("live-search-wrapper")) {
  customElements.define("live-search-wrapper", LiveSearchWrapper);
}
